var map = {
	"./en/Advantages and Limitations of the Gym.pdf": 6364,
	"./en/Cultivating a Culture of Physical Activity Among Physical Education Student Teachers at Kibbutzim College.pdf": 9920,
	"./en/Developing a Multimedia Guide to Working Out in the Gym.pdf": 161,
	"./en/Difficulties and Challenges in Physical Education.pdf": 6235,
	"./en/Flexibility - From Theory to Practice.pdf": 2962,
	"./en/Futsal Player Guidelines.pdf": 7035,
	"./en/Getting Back in Shape After the Holiday Season.pdf": 590,
	"./en/Long-term  effectiveness of structured fitness programme on students physical achivements, motivation and awareness of fitness essence.pdf": 6826,
	"./en/Preliminary Steps in Self Management Program with a Holistic.pdf": 6196,
	"./en/Sleep - Who Needs It Anyway.pdf": 9355,
	"./en/The Differences Between Women and Men.pdf": 8633,
	"./en/The Effect of Moderate or Vigorous Physical Activity on Subsequent Concentra.pdf": 7066,
	"./en/The Impact of Multimedia Integration in Teaching Programs Among Students.pdf": 5921,
	"./en/The gym as a heterotopia.pdf": 7922,
	"./en/Using a Multimedia Learning Resource to Enhance Understanding of Daily Exercise Practical Considerations.pdf": 9944,
	"./en/Warm-up in Physical Training- Everything You Need to Know.pdf": 7255,
	"./en/stretching-flexibility.pdf": 4090,
	"./he/active-colture.pdf": 4977,
	"./he/cat-regel.pdf": 3835,
	"./he/first-steps-gym.pdf": 2332,
	"./he/gym-hetrotherapy.pdf": 3004,
	"./he/gym-pros-cons.pdf": 3269,
	"./he/man vs woman anatomy.pdf": 8324,
	"./he/multimedia-students.pdf": 7197,
	"./he/post-holiday.pdf": 8771,
	"./he/sleep.pdf": 1421,
	"./he/sport-evolution.pdf": 3673,
	"./he/sport-focus.pdf": 641,
	"./he/sport-hardships.pdf": 5467,
	"./he/stretching - theory to practice.pdf": 1306,
	"./he/stretching-flexibility.pdf": 3830,
	"./he/stretching.pdf": 3362,
	"./he/whole-truth-warm-up.pdf": 5219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3126;